import { Redirect, Switch } from 'react-router-dom';

import PropTypes from 'prop-types';

import Route from './SentryRoute';

const RedirectRoutes = ({ location: { pathname, search }, match: { url } }) => {
  const newUrl = pathname.replace(url, url.slice(0, -1));
  return (
    <Switch>
      <Route>
        <Redirect
          to={{
            pathname: newUrl,
            search,
          }}
        />
      </Route>
    </Switch>
  );
};

RedirectRoutes.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default RedirectRoutes;
